import React, { Component, PropTypes } from 'react'
require('../styles/modules/about.scss');

class UnderConstruction extends Component {

  render() {
    return (
      <div className = "construction">
        Currently Under Construction. Come back Soon!
      </div>
    )
  }
}

export default UnderConstruction



// WEBPACK FOOTER //
// ./containers/UnderConstruction.js